<template>
  <div id="app" :style="{'font-family': font}">
    <Navi />
    <ToolBar class="toolbar-desktop" />
    <div class="view">
      <ToolBar class="toolbar-phone" />
      <keep-alive>
        <router-view class="router-view" />
      </keep-alive>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Navi from "@/components/Navi.vue";
import Bottom from "@/components/Bottom.vue";
import ToolBar from "@/components/ToolBar.vue";
export default {
  name: "app",
  components: { Navi, Bottom, ToolBar },
  computed: {
    font() {
      return {
        ja:
          "'Avenir', Verdana, 'Helvetica', Verdana, 'ヒラギノ角ゴシック', 'Hiragino Sans', 'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', 'メイリオ', 'Meiryo', 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif",
        zh:
          "'Avenir', Verdana, 'Helvetica', Verdana, 'Hiragino Sans GB', 'Heiti SC', 'WenQuanYi Micro Hei', 'Microsoft Yahei', sans-serif",
        en: "'Avenir', Verdana, 'Helvetica', Verdana, Arial, sans-serif"
      }[this.$i18n.locale];
    }
  },
  methods: {
    setLocale(lang) {
      this.$i18n.locale = lang;
    }
  },
  mounted() {
    var lang = navigator.language || navigator.userLanguage;
    lang = lang.substr(0, 2);
    this.setLocale(lang);
  }
};
</script>

<style lang="scss">
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme(
  "default",
  (
    primary: md-get-palette-color(purple, 700),
    accent: md-get-palette-color(purple, A200)
  )
);

@import "~vue-material/dist/theme/all"; // Apply the theme
</style>

<style lang="scss">
@import "~vue-material/src/components/MdLayout/mixins";

.view {
  padding: 64px 0 0 256px;
  @include md-layout-small {
    padding: 48px 0 0 256px;
  }
  @include md-layout-xsmall {
    padding: 0 0 64px 0;
  }
}

.router-view {
  max-width: 1024px;
  margin: auto;
}

.md-input {
  overflow: hidden;
}

.MathJax {
  outline: 0;
}

p {
  line-height: 150%;
  font-size: 16px;
}
</style>
